import React from 'react';
import { Link } from 'react-router-dom';
import { useCart } from '../../contexts/CartContext';
import '../../css/minicart.css';

const MiniCart = ({ isOpen, onClose }) => {
  const { cartItems, cartTotal, updateCartItem, removeFromCart, clearCartNotification } = useCart();

  if (!isOpen || !cartItems || cartItems.length === 0) {
    return null;
  }

  const handleQuantityChange = async (itemId, newQuantity) => {
    if (newQuantity < 1) {
      await removeFromCart(itemId);
    } else {
      await updateCartItem(itemId, newQuantity);
    }
  };

  const handleClose = () => {
    clearCartNotification();
    if (onClose) onClose();
  };

  return (
    <>
      <div className="minicart-overlay" onClick={handleClose}></div>
      <div className="minicart-container">
        <div className="minicart-header">
          <h3>Cart ({cartItems.length} {cartItems.length === 1 ? 'item' : 'items'})</h3>
          <button className="minicart-close" onClick={handleClose} aria-label="Close mini cart">
            <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
              <line x1="18" y1="6" x2="6" y2="18"></line>
              <line x1="6" y1="6" x2="18" y2="18"></line>
            </svg>
          </button>
        </div>

        <div className="minicart-items">
          {cartItems.map((item) => (
            <div key={item.id} className="minicart-item">
              <div className="minicart-item-details">
                <h4>{item.service.name}</h4>
                <p className="minicart-item-price">${parseFloat(item.service.price).toFixed(2)}</p>
              </div>

              <div className="minicart-item-actions">
                <div className="quantity-controls">
                  <button
                    onClick={() => handleQuantityChange(item.id, item.quantity - 1)}
                    className="quantity-btn"
                    aria-label="Decrease quantity"
                  >
                    −
                  </button>
                  <span className="quantity-display">{item.quantity}</span>
                  <button
                    onClick={() => handleQuantityChange(item.id, item.quantity + 1)}
                    className="quantity-btn"
                    aria-label="Increase quantity"
                  >
                    +
                  </button>
                </div>

                <button
                  onClick={() => removeFromCart(item.id)}
                  className="remove-btn"
                  aria-label="Remove from cart"
                >
                  <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                    <polyline points="3 6 5 6 21 6"></polyline>
                    <path d="M19 6v14a2 2 0 0 1-2 2H7a2 2 0 0 1-2-2V6m3 0V4a2 2 0 0 1 2-2h4a2 2 0 0 1 2 2v2"></path>
                  </svg>
                </button>
              </div>
            </div>
          ))}
        </div>

        <div className="minicart-footer">
          <div className="minicart-total">
            <span>Total:</span>
            <span className="total-amount">${cartTotal.toFixed(2)}</span>
          </div>

          <Link to="/cart" className="minicart-btn-primary" onClick={handleClose}>
            Manage Cart
          </Link>
        </div>
      </div>
    </>
  );
};

export default MiniCart;
